import { useNavigate } from "react-router-dom";
import RiskFreeIcon1 from "../../assets/home/risk-free-icon1.png"
import RiskFreeIcon2 from "../../assets/home/risk-free-icon2.png"
import RiskFreeIcon3 from "../../assets/home/risk-free-icon3.png"
import RiskFreeIcon4 from "../../assets/home/risk-free-icon4.png"
import Image from '../../components/general/Image';
import Button from '../../components/general/Button';
import StarOrange from "../../assets/home/StarOrange.svg"
import StarWhite from "../../assets/home/StartWhite.svg"
import HighRiskFreeBackground from "../../assets/home/HighRiskFreeBackground.png"

const ServicesSection = () => {
    const backgroundImage = {
        backgroundImage: `url(${HighRiskFreeBackground})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        color: 'black',
        position: 'relative',
        zIndex: '0',
      }

    return (
        <section className="-mt-[40px] !pt-[100px] md:!pt-[150px] !pb-[50px] lg:!pb-[100px] lg:!pt-[100px] bg-black" style={backgroundImage}>
            <div className="--layout-padding max-width text-white">
                <div className="highRiskCon">
                    <div className="highRiskText">
                        <h3 className="text-[30px] lg:text-55 text-center font-semibold">
                            What we do for you
                            <div className='hidden lg:inline-flex lg:-translate-y-[20px]'>
                                <Image src={StarOrange} alt="" className='w-[50px]' />
                                <Image src={StarWhite} alt="" className='w-[20px] h-[20px]' />
                            </div>
                        </h3>
                    </div>
                    <div className="mt-[20px] lg:mt-[50px]">
                        <ul className='flex flex-col md:grid md:grid-cols-2 gap-[30px] lg:grid-cols-4 justify-center'>
                            <li className=''>
                                <figure className='mb-[20px]'><Image src={RiskFreeIcon1} className='mx-auto lg:mx-0' alt="" /></figure>
                                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Rigorous Talent <br /> Screening </h4>
                                <p className='text-[14px] text-center lg:text-left mt-[10px]'>We handpick developers who excel in coding, communication, and collaboration. Only the best move forward.</p>
                            </li>
                            <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                                <figure className='mb-[20px]'><Image src={RiskFreeIcon2} className='mx-auto lg:mx-0' alt="" /></figure>
                                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Tailored Team <br /> Buildingg </h4>
                                <p className='text-[14px] text-center lg:text-left mt-[10px]'>We don’t rely on algorithms. Every match is human-curated based on your goals and culture.</p>
                            </li>
                            <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                                <figure className='mb-[20px]'><Image src={RiskFreeIcon3} className='mx-auto lg:mx-0' alt="" /></figure>
                                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Seamless Setup <br /> & Admin</h4>
                                <p className='text-[14px] text-center lg:text-left mt-[10px]'>We handle contracts, compliance, onboarding, and payments — you stay focused on results.</p>
                            </li>
                            <li className='lg:border-l lg:border-[#787878] lg:pl-[30px]'>
                                <figure className='mb-[20px]'><Image src={RiskFreeIcon4} className='mx-auto lg:mx-0' alt="" /></figure>
                                <h4 className='text-[20px] font-semibold text-center lg:text-left'>Reliable Project <br /> Backup </h4>
                                <p className='text-[14px] text-center lg:text-left mt-[10px]'>Dedicated success managers, free replacements, and proactive solutions whenever you need backup.</p>
                            </li>
                        </ul>
                    </div>
                    <div className="text-center my-[20px] md:my-[50px] lg:my-0 lg:mt-[50px]">
                        <Button className='bg-primary-color text-black w-[200px] h-[50px] mx-auto rounded text-[16px]'>Hire with confidence <i className="fa-solid fa-arrow-up-right" /></Button>
                    </div>
                </div>
            </div>
        </section>

    );
};
export default ServicesSection;